import { LoyaltyProgram } from '@wix/ambassador-loyalty-v1-program/types';
import { Reward, RewardType } from '@wix/ambassador-loyalty-v1-reward/types';
import { Tier } from '@wix/ambassador-loyalty-v1-tier/types';
import { CouponNames } from '@wix/loyalty-coupon-names';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

import { SimpleReward } from '../../types/domain';
import { createRewardDescription } from '../create-reward-description';

interface ToSimpleRewardsParams {
  rewards: Reward[];
  flowAPI: ControllerFlowAPI;
  loyaltyProgram: LoyaltyProgram;
  couponNames: CouponNames;
  tiers: Tier[];
}

export const toSimpleRewards = ({
  rewards,
  flowAPI,
  loyaltyProgram,
  couponNames,
  tiers,
}: ToSimpleRewardsParams): SimpleReward[] => {
  const commonDescParams = {
    loyaltyProgram,
    flowAPI,
    couponNames,
  };

  return rewards.reduce<SimpleReward[]>((result, reward) => {
    if (!reward.active) {
      return result;
    }

    const simpleRewards: SimpleReward[] = [];
    const title = reward.name ?? '';

    if (reward.type === RewardType.DISCOUNT_AMOUNT) {
      reward.discountAmount?.configsByTier?.forEach(({ tierId }, configIndex) => {
        simpleRewards.push({
          title,
          description: createRewardDescription({ ...commonDescParams, reward, configIndex }),
          tierId,
        });
      });
    } else if (reward.type === RewardType.SPI_DISCOUNT_AMOUNT) {
      const description = reward.spiDiscountAmount?.description ?? '';

      simpleRewards.push({ title, description }); // Base tier

      // Other tiers (SPI flexible rewards are listed as if they are available for all tiers)
      tiers.forEach(({ id: tierId }) => {
        simpleRewards.push({ title, description, tierId });
      });
    } else if (reward.type === RewardType.COUPON_REWARD) {
      const { couponReward } = reward;
      const configsByTier =
        couponReward?.percentage?.configsByTier ??
        couponReward?.fixedAmount?.configsByTier ??
        couponReward?.freeShipping?.configsByTier;

      configsByTier?.forEach(({ tierId }, configIndex) => {
        simpleRewards.push({
          title,
          description: createRewardDescription({ ...commonDescParams, reward, configIndex }),
          tierId,
        });
      });
    }

    return [...result, ...simpleRewards];
  }, []);
};
